import { IUiIcon } from '../../../types/ui'

export const IconAward = (
	{
		size = 24,
		imgSize = 24,
		fill = 'none',
		stroke = 'currentColor'
	}: IUiIcon
) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg"
		     width={`${size}px`}
		     height={`${size}px`}
		     viewBox={`0 0 ${imgSize} ${imgSize}`}
		     fill={fill}
		     stroke={stroke}
		     strokeWidth="2"
		     strokeLinecap="round"
		     strokeLinejoin="round"
		     className="feather feather-award"
		>
			<circle cx="12" cy="8" r="7"></circle>
			<polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>
		</svg>
	)
}